import { ApiUrl } from "../components/Common/ApiUrl";
import { Constants } from "../components/Common/Constants";
import httpServiceInstance from "../helper/HttpService";

export const exerciseAdd = async (data) => {
  const response = await httpServiceInstance.postNew(ApiUrl.EXERCISE, data);
  console.log("Add Response :", response);
  return response;
};

export const exerciseEdit = async (data) => {
  const response = await httpServiceInstance.patchNew(ApiUrl.EXERCISE, data);
  console.log("status::", response.status);
  console.log("Edit Response :", response.data.data);
  return response;
};

export const exerciseRemove = async (id) => {
  const response = await httpServiceInstance.delete(ApiUrl.EXERCISE + `/${id}`);
  return response;
};

export const exercise = async (data) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.EXERCISE}${
      data?.skipPagination
        ? `?${Constants.paginationFalse}`
        : `?skip=${data?.skip || 0}&limit=${
            data?.limit || Constants.limitCount
          }`
    }${data && data?.search ? `&search=${data?.search}` : ""}${
      data?.status ? `&status=${data?.status}` : ""
    }`
  );
  return response;
};

/* export const convertHLS1 = async ({ fileName, fieldKey, exerciseId }) => {
  const response = await httpServiceInstance.get(
    `${ApiUrl.CONVERT_HLS}?video_key=${fileName}&field_key=${fieldKey}&exercise_id=${exerciseId}`
  );
  return response;
};
 */
/* export const convertHLS = async ({ fileName, fieldKey, exerciseId }) => {
  const baseUrl = `${process.env.REACT_APP_HLS_URL}`;
  const fullUrl = `${baseUrl}${ApiUrl.CONVERT_HLS}?video_key=${fileName}&field_key=${fieldKey}&exercise_id=${exerciseId}`;
  console.log("FullUrl", fullUrl);
  const response = await httpServiceInstance.get(fullUrl);
  return response;
}; */

export const convertHLS = ({ fileName, fieldKey, exerciseId }) => {
  const baseUrl = `${process.env.REACT_APP_HLS_URL}`;
  const fullUrl = `${baseUrl}${ApiUrl.CONVERT_HLS}?video_key=${fileName}&field_key=${fieldKey}&exercise_id=${exerciseId}`;
  console.log("FullUrl", fullUrl);

  // Fire and forget — don't await, don't return
  httpServiceInstance.get(fullUrl).catch((err) => {
    console.warn("convertHLS request failed (ignored):", err.message);
  });
};


